import { useState } from 'react'
import { FormikConfig } from 'formik'
import { notification } from '@/shared/helpers/notificationMessages'
import { errorHandler } from '@/shared/lib/errorHandler'
import { useTranslation } from 'react-i18next'
import { createPromotionFormDefault } from './consts'
import { CreatePromotionFormState } from '../model/types'
import { useCreatePromotionApi } from '../api/create-promotion-form-api'
import { useLanguageStore } from '@/widgets/LanguageSelect/model/store'
import { useResidentialsByPage } from '@/entities/Residential'
import { useDebounce } from '@/shared/lib/useDebounce'

type UseCreatePromotionFormProps = {
  onCloseModal: () => void
}

export const useCreatePromotionForm = (props: UseCreatePromotionFormProps) => {
  const { onCloseModal } = props
  const { t } = useTranslation(['common'])
  const { language } = useLanguageStore()
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedSearchValue = useDebounce(searchQuery, 500)
  const [initialValues, setInitialValues] = useState<CreatePromotionFormState>(
    () => createPromotionFormDefault,
  )

  const { data: residentials, isLoading } = useResidentialsByPage({
    limit: 100,
    offset: 0,
    search: debouncedSearchValue,
    language,
    checked_manual: true,
  })

  const { mutateAsync, isPending: isLoadingCreatePromotion } = useCreatePromotionApi()

  const submitForm: FormikConfig<CreatePromotionFormState>['onSubmit'] = async values => {
    onCloseModal()

    try {
      await mutateAsync(values)
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.create_promotion_success'),
      )
    } catch (error) {
      errorHandler(error, t('common:notification_messages.create_promotion_error'))
    }
  }
  const residentialProjects =
    residentials?.data?.map(residential => ({
      value: residential.id.toString(),
      label: residential.name,
    })) || []

  return {
    setInitialValues,
    initialValues,
    isLoadingCreatePromotion,
    submitForm,
    createPromotionFormDefault,
    searchQuery,
    setSearchQuery,
    residentialProjects,
    isLoading,
  }
}
